import getSlider from './slider';
import getZoom from './zoom';
import getSliderZoom from './slider-zoom';
import getTwoStepZoom from './two-step-zoom';
import getTwoStepSliderZoom from './two-step-slider-zoom';

export {getSlider, getZoom, getSliderZoom, getTwoStepZoom, getTwoStepSliderZoom};
